import { convertToSlug } from './IdGenerator'

// Extract ID from h2 content and headerTabName
export const extractIdFromContent = (sectionHeading: string, headerTabName: string): string => {
  const h2Regex = /<h2[^>]*>(.*?)<\/h2>/
  const matches = sectionHeading?.match(h2Regex)
  const h2Content = matches ? matches[1] : null
  const idContent = headerTabName || h2Content || ''
  return convertToSlug(idContent)
}
